import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IAddUnMatchTransactionRequest {
  uyeRefNo: string
}

async function addUnMatchTransaction(data: IAddUnMatchTransactionRequest): Promise<any> {
  try {
    return (await axiosInstance.post("/Transaction/AddUnMatchTransaction", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddUnMatchTransaction() {
  return useMutation<any, Error, IAddUnMatchTransactionRequest>(
    (variables) => addUnMatchTransaction(variables)
  );
}
